module.exports = __webpack_public_path__ + "static/media/logo-coursera-blanco.8ec54c28.png";